
const Footer = () => {
  return (
      <footer className="p-4 md:p-8">
      <p className="text-white text-center text-base">
        Copyright © Club FM 2026. All right reserved
      </p>
    </footer>
  )
}

export default Footer;
